
export default function About() {
  const metrics = [
    { value: '99.8%', label: 'Uptime Guarantee' },
    { value: '24/7', label: 'Support Available' }
  ];

  return (
    <section id="about" className="py-40 px-20 bg-gradient-to-br from-amber-50/30 via-orange-50/20 to-amber-50/30">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-12 gap-16">
          <div className="col-span-5">
            <div className="flex items-center gap-3 mb-20">
              <div className="w-2 h-2 rounded-full bg-gray-900"></div>
              <span className="text-xs tracking-widest text-gray-700 font-medium">ABOUT US</span>
            </div>
            
            <p className="text-3xl leading-relaxed text-gray-800" style={{ fontFamily: 'Playfair Display, serif' }}>
              LEMUR d.o.o. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>
          
          <div className="col-span-7">
            <div className="grid grid-cols-2 gap-x-20 gap-y-16">
              {metrics.map((metric, index) => (
                <div key={index} className="group cursor-default">
                  <div className="text-6xl font-bold text-gray-900 mb-3 transition-all duration-300 group-hover:text-orange-500">
                    {metric.value}
                  </div>
                  <div className="text-base text-gray-600 font-light">
                    {metric.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
